var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / JE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666666667,3.83333333 L0.666666667,2.67435201 C0.666666667,1.93372785 1.25688044,1.33333333 1.99860875,1.33333333 L3.33472459,1.33333333 C4.07033588,1.33333333 4.66666667,1.9209166 4.66666667,2.67435201 L4.66666667,3.83333333 C4.66666667,5.61904762 2.66666667,6.33333333 2.66666667,6.33333333 C2.66666667,6.33333333 0.666666667,5.61904762 0.666666667,3.83333333 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-JE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1278",
    fill: "#E3243B",
    mask: "url(#mask-2)",
    transform: "translate(14.659027, 10.473202) rotate(-55.000000) translate(-14.659027, -10.473202) ",
    x: 13.3256942,
    y: -14.1934652,
    width: 2.66666667,
    height: 49.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1278",
    fill: "#E3243B",
    mask: "url(#mask-2)",
    transform: "translate(14.659027, 10.473202) scale(-1, 1) rotate(-55.000000) translate(-14.659027, -10.473202) ",
    x: 13.3256942,
    y: -14.1934652,
    width: 2.66666667,
    height: 49.3333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 1.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54383226,0 L3.36444772,0.854754367 L4.64028925,0.712295322 L3.65347796,1.28213158 L3.74004409,1.333 L1.59204409,1.333 L1.67985538,1.28213158 L0.693044087,0.712295303 L1.96888566,0.854754367 L1.78950107,0 L2.66666666,0.712295303 L3.54383226,0 Z",
    id: "Star-1",
    stroke: "none",
    fill: "#FAEF32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#E3243B",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1281",
    stroke: "none",
    fill: "#FAEF32",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    x: 2.33333333,
    y: 5.33333333,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1281",
    stroke: "none",
    fill: "#FAEF32",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    x: 1.33333333,
    y: 4,
    width: 2.66666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1281",
    stroke: "none",
    fill: "#FAEF32",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    x: 1.33333333,
    y: 2.66666667,
    width: 2.66666667,
    height: 1,
    rx: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJe);
export default __webpack_public_path__ + "static/media/JE.c6873fb8289aab7e8ff37cf954122800.svg";
export { ForwardRef as ReactComponent };